module.exports = __webpack_public_path__ + "img/icon_gongpai2@2x.c035f1c6.png";